import { createSelector } from 'reselect';
import { initialState } from '../reducers/scenario.reducer';
import { SCENARIOS } from '../constants/scenario.constants';

const selectState = state => state?.[SCENARIOS] || initialState;

const selectScenariosData = createSelector(
  selectState,
  state => state.get('data')
);

const selectScenariosList = createSelector(
  selectScenariosData,
  data => data.toList()
);

export const selectScenarios = createSelector(
  selectScenariosList,
  scenarios => scenarios.filter(s => !!s)
);

export const selectScenariosFetched = createSelector(
  selectState,
  state => state.get('fetched')
);

export const selectSelectedScenario = createSelector(
  selectState,
  state => state.get('selectedScenario')
);